export const prescriptionPosology = [
    { posologiaNome: "1 POR DIA" },
    { posologiaNome: "6 EM 6 HORAS" },
    { posologiaNome: "8 EM 8 HORAS" },
    { posologiaNome: "12 EM 12 HORAS" },
    { posologiaNome: "SOS" },
    { posologiaNome: "INTERVALO DIAS" },
    { posologiaNome: "PERSONALIZADO" },
];
